import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { reducer as IncidentsFilterReducer, State as IncidentsFilterState } from './incidents-filter.reducer';
import { reducer as IncidentTagsFilterReducer, State as IncidentTagsFilterState } from './incident-filter-tags.reducer';
import { reducer as IncidentViewTypeReducer, State as IncidentViewTypeState } from './incident-view-type.reducer';

export interface State {
  incidentsFilter: IncidentsFilterState;
  incidentTagsFilter: IncidentTagsFilterState;
  incidentListview: IncidentViewTypeState;
}

export { IncidentsFilterState };

export const reducers: ActionReducerMap<State> = {
  incidentsFilter: IncidentsFilterReducer,
  incidentTagsFilter: IncidentTagsFilterReducer,
  incidentListview: IncidentViewTypeReducer,
};

// Selectors
export const getIncidentsState = createFeatureSelector<State>('incidents');

export const getIncidentsFilter = createSelector(getIncidentsState, (state: State) => state.incidentsFilter);

export const getIncidentTags = createSelector(getIncidentsState, (state: State) => state.incidentTagsFilter);

export const getIncidentsViewType = createSelector(getIncidentsState, (state: State) => state.incidentListview);
